import { REAGION_SOATO } from '@/common/constants/regions';
import {
  Column,
  MasterApprenticesRepublic,
} from '@/features/teacher-student/models/master-apprentices.model';
import { useMasterApprenticesStore } from '@/features/teacher-student/store';
import { useEffect, useMemo } from 'react';

export default function useTable() {
  const {
    masterApprenticesRepublic,
    fetchMasterApprenticesRepublic,
    isMasterApprenticesRepublicLoading,
  } = useMasterApprenticesStore();

  const columns: Column<MasterApprenticesRepublic>[] = [
    {
      key: 'id',
      label: '#',
      header: '#',
      align: 'left',
      cell: (_, index) => <span className="text-gray-600">{index + 1}</span>,
    },
    {
      key: 'region_name',
      label: 'Viloyat nomi',
      header: 'Viloyat nomi',
      align: 'left',
    },
    {
      key: 'cotton_yield_under_60',
      label: "Hosildorlik 60 sentnerdan ko'p klaster",
      align: 'center',
      cell: (row) => row?.cotton_yield_under_60,
    },
    {
      key: 'masters_count',
      label: 'Ustoz f/x lar soni',
      align: 'center',
      cell: (row) => row?.masters_count,
    },
    {
      key: 'cotton_yield_above_30',
      label: 'Hosildorlik 30 sentnerdan kam klaster',
      align: 'center',
      cell: (row) => row?.cotton_yield_above_30,
    },
    {
      key: 'apprentices_count',
      label: 'Shogird f/x lar soni',
      align: 'center',
      cell: (row) => row?.apprentices_count,
    },
  ];

  const totals = useMemo(() => {
    if (!masterApprenticesRepublic || masterApprenticesRepublic.length === 0) {
      return {
        cotton_yield_under_60: 0,
        cotton_yield_above_30: 0,
        masters_count: 0,
        apprentices_count: 0,
      };
    }

    return masterApprenticesRepublic.reduce(
      (acc, row) => ({
        cotton_yield_under_60:
          acc.cotton_yield_under_60 + Number(row.cotton_yield_under_60 || 0),
        cotton_yield_above_30:
          acc.cotton_yield_above_30 + Number(row.cotton_yield_above_30 || 0),
        masters_count: acc.masters_count + Number(row.masters_count || 0),
        apprentices_count:
          acc.apprentices_count + Number(row.apprentices_count || 0),
      }),
      {
        cotton_yield_under_60: 0,
        cotton_yield_above_30: 0,
        masters_count: 0,
        apprentices_count: 0,
      },
    );
  }, [masterApprenticesRepublic]);

  useEffect(() => {
    fetchMasterApprenticesRepublic();
  }, []);

  const sortedData = useMemo(() => {
    if (!masterApprenticesRepublic) return [];
    return [...masterApprenticesRepublic].sort((a, b) => {
      const indexA = REAGION_SOATO.findIndex((item) => item.id === a.region_id);
      const indexB = REAGION_SOATO.findIndex((item) => item.id === b.region_id);
      return indexA - indexB;
    });
  }, [masterApprenticesRepublic]);

  return {
    columns,
    masterApprenticesRepublic: sortedData,
    isMasterApprenticesRepublicLoading,
    totals,
  };
}
